/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TimelineRouteImport } from './routes/timeline'
import { Route as TextsRouteImport } from './routes/texts'
import { Route as StoryboardRouteImport } from './routes/storyboard'
import { Route as RestoreAccountRouteImport } from './routes/restore-account'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as NotesRouteImport } from './routes/notes'
import { Route as NarrativeStructureRouteImport } from './routes/narrative-structure'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as ExportRouteImport } from './routes/export'
import { Route as EditorRouteImport } from './routes/editor'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout-success'
import { Route as CheckoutCancelRouteImport } from './routes/checkout-cancel'
import { Route as AdeptusAdministratumRouteImport } from './routes/adeptus-administratum'
import { Route as AccountPendingDeletionRouteImport } from './routes/account-pending-deletion'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ScenesIndexRouteImport } from './routes/scenes/index'
import { Route as RelationshipsIndexRouteImport } from './routes/relationships/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as LocationsIndexRouteImport } from './routes/locations/index'
import { Route as ImportIndexRouteImport } from './routes/import/index'
import { Route as EventsIndexRouteImport } from './routes/events/index'
import { Route as CodexIndexRouteImport } from './routes/codex/index'
import { Route as CharactersIndexRouteImport } from './routes/characters/index'
import { Route as ArcsIndexRouteImport } from './routes/arcs/index'
import { Route as ScenesNewRouteImport } from './routes/scenes/new'
import { Route as ReadNovelIdRouteImport } from './routes/read.$novelId'
import { Route as PublishEditorChapterIdRouteImport } from './routes/publish-editor.$chapterId'
import { Route as OrganizationsSettingsRouteImport } from './routes/organizations/settings'
import { Route as OrganizationsNewRouteImport } from './routes/organizations/new'
import { Route as LocationsSettingsRouteImport } from './routes/locations/settings'
import { Route as LocationsNewRouteImport } from './routes/locations/new'
import { Route as EventsSettingsRouteImport } from './routes/events/settings'
import { Route as EventsNewRouteImport } from './routes/events/new'
import { Route as CodexSettingsRouteImport } from './routes/codex/settings'
import { Route as CodexNewRouteImport } from './routes/codex/new'
import { Route as CharactersSettingsRouteImport } from './routes/characters/settings'
import { Route as CharactersNewRouteImport } from './routes/characters/new'
import { Route as ArcsIdRouteImport } from './routes/arcs/$id'
import { Route as ReadNovelIdIndexRouteImport } from './routes/read.$novelId.index'
import { Route as ScenesViewIdRouteImport } from './routes/scenes/view/$id'
import { Route as ScenesEditIdRouteImport } from './routes/scenes/edit/$id'
import { Route as RelationshipsEntityTypeIdRouteImport } from './routes/relationships/$entityType/$id'
import { Route as ReadNovelIdChapterIdRouteImport } from './routes/read.$novelId.$chapterId'
import { Route as OrganizationsViewIdRouteImport } from './routes/organizations/view/$id'
import { Route as OrganizationsEditIdRouteImport } from './routes/organizations/edit/$id'
import { Route as LocationsViewIdRouteImport } from './routes/locations/view/$id'
import { Route as LocationsMapIdRouteImport } from './routes/locations/map/$id'
import { Route as LocationsEditIdRouteImport } from './routes/locations/edit/$id'
import { Route as ImportReviewSessionIdRouteImport } from './routes/import/review.$sessionId'
import { Route as ImportProcessingSessionIdRouteImport } from './routes/import/processing.$sessionId'
import { Route as EventsViewIdRouteImport } from './routes/events/view/$id'
import { Route as EventsEditIdRouteImport } from './routes/events/edit/$id'
import { Route as CodexViewIdRouteImport } from './routes/codex/view/$id'
import { Route as CodexEditIdRouteImport } from './routes/codex/edit/$id'
import { Route as CharactersViewIdRouteImport } from './routes/characters/view/$id'
import { Route as CharactersEditIdRouteImport } from './routes/characters/edit/$id'

const TimelineRoute = TimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const TextsRoute = TextsRouteImport.update({
  id: '/texts',
  path: '/texts',
  getParentRoute: () => rootRouteImport,
} as any)
const StoryboardRoute = StoryboardRouteImport.update({
  id: '/storyboard',
  path: '/storyboard',
  getParentRoute: () => rootRouteImport,
} as any)
const RestoreAccountRoute = RestoreAccountRouteImport.update({
  id: '/restore-account',
  path: '/restore-account',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const NotesRoute = NotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => rootRouteImport,
} as any)
const NarrativeStructureRoute = NarrativeStructureRouteImport.update({
  id: '/narrative-structure',
  path: '/narrative-structure',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportRoute = ExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorRoute = EditorRouteImport.update({
  id: '/editor',
  path: '/editor',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout-success',
  path: '/checkout-success',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
  id: '/checkout-cancel',
  path: '/checkout-cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const AdeptusAdministratumRoute = AdeptusAdministratumRouteImport.update({
  id: '/adeptus-administratum',
  path: '/adeptus-administratum',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountPendingDeletionRoute = AccountPendingDeletionRouteImport.update({
  id: '/account-pending-deletion',
  path: '/account-pending-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScenesIndexRoute = ScenesIndexRouteImport.update({
  id: '/scenes/',
  path: '/scenes/',
  getParentRoute: () => rootRouteImport,
} as any)
const RelationshipsIndexRoute = RelationshipsIndexRouteImport.update({
  id: '/relationships/',
  path: '/relationships/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsIndexRoute = LocationsIndexRouteImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportIndexRoute = ImportIndexRouteImport.update({
  id: '/import/',
  path: '/import/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const CodexIndexRoute = CodexIndexRouteImport.update({
  id: '/codex/',
  path: '/codex/',
  getParentRoute: () => rootRouteImport,
} as any)
const CharactersIndexRoute = CharactersIndexRouteImport.update({
  id: '/characters/',
  path: '/characters/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArcsIndexRoute = ArcsIndexRouteImport.update({
  id: '/arcs/',
  path: '/arcs/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScenesNewRoute = ScenesNewRouteImport.update({
  id: '/scenes/new',
  path: '/scenes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadNovelIdRoute = ReadNovelIdRouteImport.update({
  id: '/read/$novelId',
  path: '/read/$novelId',
  getParentRoute: () => rootRouteImport,
} as any)
const PublishEditorChapterIdRoute = PublishEditorChapterIdRouteImport.update({
  id: '/publish-editor/$chapterId',
  path: '/publish-editor/$chapterId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsSettingsRoute = OrganizationsSettingsRouteImport.update({
  id: '/organizations/settings',
  path: '/organizations/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsNewRoute = OrganizationsNewRouteImport.update({
  id: '/organizations/new',
  path: '/organizations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsSettingsRoute = LocationsSettingsRouteImport.update({
  id: '/locations/settings',
  path: '/locations/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsNewRoute = LocationsNewRouteImport.update({
  id: '/locations/new',
  path: '/locations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsSettingsRoute = EventsSettingsRouteImport.update({
  id: '/events/settings',
  path: '/events/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsNewRoute = EventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CodexSettingsRoute = CodexSettingsRouteImport.update({
  id: '/codex/settings',
  path: '/codex/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const CodexNewRoute = CodexNewRouteImport.update({
  id: '/codex/new',
  path: '/codex/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CharactersSettingsRoute = CharactersSettingsRouteImport.update({
  id: '/characters/settings',
  path: '/characters/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const CharactersNewRoute = CharactersNewRouteImport.update({
  id: '/characters/new',
  path: '/characters/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ArcsIdRoute = ArcsIdRouteImport.update({
  id: '/arcs/$id',
  path: '/arcs/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadNovelIdIndexRoute = ReadNovelIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReadNovelIdRoute,
} as any)
const ScenesViewIdRoute = ScenesViewIdRouteImport.update({
  id: '/scenes/view/$id',
  path: '/scenes/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ScenesEditIdRoute = ScenesEditIdRouteImport.update({
  id: '/scenes/edit/$id',
  path: '/scenes/edit/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RelationshipsEntityTypeIdRoute =
  RelationshipsEntityTypeIdRouteImport.update({
    id: '/relationships/$entityType/$id',
    path: '/relationships/$entityType/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReadNovelIdChapterIdRoute = ReadNovelIdChapterIdRouteImport.update({
  id: '/$chapterId',
  path: '/$chapterId',
  getParentRoute: () => ReadNovelIdRoute,
} as any)
const OrganizationsViewIdRoute = OrganizationsViewIdRouteImport.update({
  id: '/organizations/view/$id',
  path: '/organizations/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsEditIdRoute = OrganizationsEditIdRouteImport.update({
  id: '/organizations/edit/$id',
  path: '/organizations/edit/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsViewIdRoute = LocationsViewIdRouteImport.update({
  id: '/locations/view/$id',
  path: '/locations/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsMapIdRoute = LocationsMapIdRouteImport.update({
  id: '/locations/map/$id',
  path: '/locations/map/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsEditIdRoute = LocationsEditIdRouteImport.update({
  id: '/locations/edit/$id',
  path: '/locations/edit/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportReviewSessionIdRoute = ImportReviewSessionIdRouteImport.update({
  id: '/import/review/$sessionId',
  path: '/import/review/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportProcessingSessionIdRoute =
  ImportProcessingSessionIdRouteImport.update({
    id: '/import/processing/$sessionId',
    path: '/import/processing/$sessionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const EventsViewIdRoute = EventsViewIdRouteImport.update({
  id: '/events/view/$id',
  path: '/events/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsEditIdRoute = EventsEditIdRouteImport.update({
  id: '/events/edit/$id',
  path: '/events/edit/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CodexViewIdRoute = CodexViewIdRouteImport.update({
  id: '/codex/view/$id',
  path: '/codex/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CodexEditIdRoute = CodexEditIdRouteImport.update({
  id: '/codex/edit/$id',
  path: '/codex/edit/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CharactersViewIdRoute = CharactersViewIdRouteImport.update({
  id: '/characters/view/$id',
  path: '/characters/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CharactersEditIdRoute = CharactersEditIdRouteImport.update({
  id: '/characters/edit/$id',
  path: '/characters/edit/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account-pending-deletion': typeof AccountPendingDeletionRoute
  '/adeptus-administratum': typeof AdeptusAdministratumRoute
  '/checkout-cancel': typeof CheckoutCancelRoute
  '/checkout-success': typeof CheckoutSuccessRoute
  '/editor': typeof EditorRoute
  '/export': typeof ExportRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/narrative-structure': typeof NarrativeStructureRoute
  '/notes': typeof NotesRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/restore-account': typeof RestoreAccountRoute
  '/storyboard': typeof StoryboardRoute
  '/texts': typeof TextsRoute
  '/timeline': typeof TimelineRoute
  '/arcs/$id': typeof ArcsIdRoute
  '/characters/new': typeof CharactersNewRoute
  '/characters/settings': typeof CharactersSettingsRoute
  '/codex/new': typeof CodexNewRoute
  '/codex/settings': typeof CodexSettingsRoute
  '/events/new': typeof EventsNewRoute
  '/events/settings': typeof EventsSettingsRoute
  '/locations/new': typeof LocationsNewRoute
  '/locations/settings': typeof LocationsSettingsRoute
  '/organizations/new': typeof OrganizationsNewRoute
  '/organizations/settings': typeof OrganizationsSettingsRoute
  '/publish-editor/$chapterId': typeof PublishEditorChapterIdRoute
  '/read/$novelId': typeof ReadNovelIdRouteWithChildren
  '/scenes/new': typeof ScenesNewRoute
  '/arcs/': typeof ArcsIndexRoute
  '/characters/': typeof CharactersIndexRoute
  '/codex/': typeof CodexIndexRoute
  '/events/': typeof EventsIndexRoute
  '/import/': typeof ImportIndexRoute
  '/locations/': typeof LocationsIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/relationships/': typeof RelationshipsIndexRoute
  '/scenes/': typeof ScenesIndexRoute
  '/characters/edit/$id': typeof CharactersEditIdRoute
  '/characters/view/$id': typeof CharactersViewIdRoute
  '/codex/edit/$id': typeof CodexEditIdRoute
  '/codex/view/$id': typeof CodexViewIdRoute
  '/events/edit/$id': typeof EventsEditIdRoute
  '/events/view/$id': typeof EventsViewIdRoute
  '/import/processing/$sessionId': typeof ImportProcessingSessionIdRoute
  '/import/review/$sessionId': typeof ImportReviewSessionIdRoute
  '/locations/edit/$id': typeof LocationsEditIdRoute
  '/locations/map/$id': typeof LocationsMapIdRoute
  '/locations/view/$id': typeof LocationsViewIdRoute
  '/organizations/edit/$id': typeof OrganizationsEditIdRoute
  '/organizations/view/$id': typeof OrganizationsViewIdRoute
  '/read/$novelId/$chapterId': typeof ReadNovelIdChapterIdRoute
  '/relationships/$entityType/$id': typeof RelationshipsEntityTypeIdRoute
  '/scenes/edit/$id': typeof ScenesEditIdRoute
  '/scenes/view/$id': typeof ScenesViewIdRoute
  '/read/$novelId/': typeof ReadNovelIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-pending-deletion': typeof AccountPendingDeletionRoute
  '/adeptus-administratum': typeof AdeptusAdministratumRoute
  '/checkout-cancel': typeof CheckoutCancelRoute
  '/checkout-success': typeof CheckoutSuccessRoute
  '/editor': typeof EditorRoute
  '/export': typeof ExportRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/narrative-structure': typeof NarrativeStructureRoute
  '/notes': typeof NotesRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/restore-account': typeof RestoreAccountRoute
  '/storyboard': typeof StoryboardRoute
  '/texts': typeof TextsRoute
  '/timeline': typeof TimelineRoute
  '/arcs/$id': typeof ArcsIdRoute
  '/characters/new': typeof CharactersNewRoute
  '/characters/settings': typeof CharactersSettingsRoute
  '/codex/new': typeof CodexNewRoute
  '/codex/settings': typeof CodexSettingsRoute
  '/events/new': typeof EventsNewRoute
  '/events/settings': typeof EventsSettingsRoute
  '/locations/new': typeof LocationsNewRoute
  '/locations/settings': typeof LocationsSettingsRoute
  '/organizations/new': typeof OrganizationsNewRoute
  '/organizations/settings': typeof OrganizationsSettingsRoute
  '/publish-editor/$chapterId': typeof PublishEditorChapterIdRoute
  '/scenes/new': typeof ScenesNewRoute
  '/arcs': typeof ArcsIndexRoute
  '/characters': typeof CharactersIndexRoute
  '/codex': typeof CodexIndexRoute
  '/events': typeof EventsIndexRoute
  '/import': typeof ImportIndexRoute
  '/locations': typeof LocationsIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/relationships': typeof RelationshipsIndexRoute
  '/scenes': typeof ScenesIndexRoute
  '/characters/edit/$id': typeof CharactersEditIdRoute
  '/characters/view/$id': typeof CharactersViewIdRoute
  '/codex/edit/$id': typeof CodexEditIdRoute
  '/codex/view/$id': typeof CodexViewIdRoute
  '/events/edit/$id': typeof EventsEditIdRoute
  '/events/view/$id': typeof EventsViewIdRoute
  '/import/processing/$sessionId': typeof ImportProcessingSessionIdRoute
  '/import/review/$sessionId': typeof ImportReviewSessionIdRoute
  '/locations/edit/$id': typeof LocationsEditIdRoute
  '/locations/map/$id': typeof LocationsMapIdRoute
  '/locations/view/$id': typeof LocationsViewIdRoute
  '/organizations/edit/$id': typeof OrganizationsEditIdRoute
  '/organizations/view/$id': typeof OrganizationsViewIdRoute
  '/read/$novelId/$chapterId': typeof ReadNovelIdChapterIdRoute
  '/relationships/$entityType/$id': typeof RelationshipsEntityTypeIdRoute
  '/scenes/edit/$id': typeof ScenesEditIdRoute
  '/scenes/view/$id': typeof ScenesViewIdRoute
  '/read/$novelId': typeof ReadNovelIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account-pending-deletion': typeof AccountPendingDeletionRoute
  '/adeptus-administratum': typeof AdeptusAdministratumRoute
  '/checkout-cancel': typeof CheckoutCancelRoute
  '/checkout-success': typeof CheckoutSuccessRoute
  '/editor': typeof EditorRoute
  '/export': typeof ExportRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/narrative-structure': typeof NarrativeStructureRoute
  '/notes': typeof NotesRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/restore-account': typeof RestoreAccountRoute
  '/storyboard': typeof StoryboardRoute
  '/texts': typeof TextsRoute
  '/timeline': typeof TimelineRoute
  '/arcs/$id': typeof ArcsIdRoute
  '/characters/new': typeof CharactersNewRoute
  '/characters/settings': typeof CharactersSettingsRoute
  '/codex/new': typeof CodexNewRoute
  '/codex/settings': typeof CodexSettingsRoute
  '/events/new': typeof EventsNewRoute
  '/events/settings': typeof EventsSettingsRoute
  '/locations/new': typeof LocationsNewRoute
  '/locations/settings': typeof LocationsSettingsRoute
  '/organizations/new': typeof OrganizationsNewRoute
  '/organizations/settings': typeof OrganizationsSettingsRoute
  '/publish-editor/$chapterId': typeof PublishEditorChapterIdRoute
  '/read/$novelId': typeof ReadNovelIdRouteWithChildren
  '/scenes/new': typeof ScenesNewRoute
  '/arcs/': typeof ArcsIndexRoute
  '/characters/': typeof CharactersIndexRoute
  '/codex/': typeof CodexIndexRoute
  '/events/': typeof EventsIndexRoute
  '/import/': typeof ImportIndexRoute
  '/locations/': typeof LocationsIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/relationships/': typeof RelationshipsIndexRoute
  '/scenes/': typeof ScenesIndexRoute
  '/characters/edit/$id': typeof CharactersEditIdRoute
  '/characters/view/$id': typeof CharactersViewIdRoute
  '/codex/edit/$id': typeof CodexEditIdRoute
  '/codex/view/$id': typeof CodexViewIdRoute
  '/events/edit/$id': typeof EventsEditIdRoute
  '/events/view/$id': typeof EventsViewIdRoute
  '/import/processing/$sessionId': typeof ImportProcessingSessionIdRoute
  '/import/review/$sessionId': typeof ImportReviewSessionIdRoute
  '/locations/edit/$id': typeof LocationsEditIdRoute
  '/locations/map/$id': typeof LocationsMapIdRoute
  '/locations/view/$id': typeof LocationsViewIdRoute
  '/organizations/edit/$id': typeof OrganizationsEditIdRoute
  '/organizations/view/$id': typeof OrganizationsViewIdRoute
  '/read/$novelId/$chapterId': typeof ReadNovelIdChapterIdRoute
  '/relationships/$entityType/$id': typeof RelationshipsEntityTypeIdRoute
  '/scenes/edit/$id': typeof ScenesEditIdRoute
  '/scenes/view/$id': typeof ScenesViewIdRoute
  '/read/$novelId/': typeof ReadNovelIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-pending-deletion'
    | '/adeptus-administratum'
    | '/checkout-cancel'
    | '/checkout-success'
    | '/editor'
    | '/export'
    | '/library'
    | '/login'
    | '/narrative-structure'
    | '/notes'
    | '/pricing'
    | '/profile'
    | '/restore-account'
    | '/storyboard'
    | '/texts'
    | '/timeline'
    | '/arcs/$id'
    | '/characters/new'
    | '/characters/settings'
    | '/codex/new'
    | '/codex/settings'
    | '/events/new'
    | '/events/settings'
    | '/locations/new'
    | '/locations/settings'
    | '/organizations/new'
    | '/organizations/settings'
    | '/publish-editor/$chapterId'
    | '/read/$novelId'
    | '/scenes/new'
    | '/arcs/'
    | '/characters/'
    | '/codex/'
    | '/events/'
    | '/import/'
    | '/locations/'
    | '/organizations/'
    | '/relationships/'
    | '/scenes/'
    | '/characters/edit/$id'
    | '/characters/view/$id'
    | '/codex/edit/$id'
    | '/codex/view/$id'
    | '/events/edit/$id'
    | '/events/view/$id'
    | '/import/processing/$sessionId'
    | '/import/review/$sessionId'
    | '/locations/edit/$id'
    | '/locations/map/$id'
    | '/locations/view/$id'
    | '/organizations/edit/$id'
    | '/organizations/view/$id'
    | '/read/$novelId/$chapterId'
    | '/relationships/$entityType/$id'
    | '/scenes/edit/$id'
    | '/scenes/view/$id'
    | '/read/$novelId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-pending-deletion'
    | '/adeptus-administratum'
    | '/checkout-cancel'
    | '/checkout-success'
    | '/editor'
    | '/export'
    | '/library'
    | '/login'
    | '/narrative-structure'
    | '/notes'
    | '/pricing'
    | '/profile'
    | '/restore-account'
    | '/storyboard'
    | '/texts'
    | '/timeline'
    | '/arcs/$id'
    | '/characters/new'
    | '/characters/settings'
    | '/codex/new'
    | '/codex/settings'
    | '/events/new'
    | '/events/settings'
    | '/locations/new'
    | '/locations/settings'
    | '/organizations/new'
    | '/organizations/settings'
    | '/publish-editor/$chapterId'
    | '/scenes/new'
    | '/arcs'
    | '/characters'
    | '/codex'
    | '/events'
    | '/import'
    | '/locations'
    | '/organizations'
    | '/relationships'
    | '/scenes'
    | '/characters/edit/$id'
    | '/characters/view/$id'
    | '/codex/edit/$id'
    | '/codex/view/$id'
    | '/events/edit/$id'
    | '/events/view/$id'
    | '/import/processing/$sessionId'
    | '/import/review/$sessionId'
    | '/locations/edit/$id'
    | '/locations/map/$id'
    | '/locations/view/$id'
    | '/organizations/edit/$id'
    | '/organizations/view/$id'
    | '/read/$novelId/$chapterId'
    | '/relationships/$entityType/$id'
    | '/scenes/edit/$id'
    | '/scenes/view/$id'
    | '/read/$novelId'
  id:
    | '__root__'
    | '/'
    | '/account-pending-deletion'
    | '/adeptus-administratum'
    | '/checkout-cancel'
    | '/checkout-success'
    | '/editor'
    | '/export'
    | '/library'
    | '/login'
    | '/narrative-structure'
    | '/notes'
    | '/pricing'
    | '/profile'
    | '/restore-account'
    | '/storyboard'
    | '/texts'
    | '/timeline'
    | '/arcs/$id'
    | '/characters/new'
    | '/characters/settings'
    | '/codex/new'
    | '/codex/settings'
    | '/events/new'
    | '/events/settings'
    | '/locations/new'
    | '/locations/settings'
    | '/organizations/new'
    | '/organizations/settings'
    | '/publish-editor/$chapterId'
    | '/read/$novelId'
    | '/scenes/new'
    | '/arcs/'
    | '/characters/'
    | '/codex/'
    | '/events/'
    | '/import/'
    | '/locations/'
    | '/organizations/'
    | '/relationships/'
    | '/scenes/'
    | '/characters/edit/$id'
    | '/characters/view/$id'
    | '/codex/edit/$id'
    | '/codex/view/$id'
    | '/events/edit/$id'
    | '/events/view/$id'
    | '/import/processing/$sessionId'
    | '/import/review/$sessionId'
    | '/locations/edit/$id'
    | '/locations/map/$id'
    | '/locations/view/$id'
    | '/organizations/edit/$id'
    | '/organizations/view/$id'
    | '/read/$novelId/$chapterId'
    | '/relationships/$entityType/$id'
    | '/scenes/edit/$id'
    | '/scenes/view/$id'
    | '/read/$novelId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountPendingDeletionRoute: typeof AccountPendingDeletionRoute
  AdeptusAdministratumRoute: typeof AdeptusAdministratumRoute
  CheckoutCancelRoute: typeof CheckoutCancelRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  EditorRoute: typeof EditorRoute
  ExportRoute: typeof ExportRoute
  LibraryRoute: typeof LibraryRoute
  LoginRoute: typeof LoginRoute
  NarrativeStructureRoute: typeof NarrativeStructureRoute
  NotesRoute: typeof NotesRoute
  PricingRoute: typeof PricingRoute
  ProfileRoute: typeof ProfileRoute
  RestoreAccountRoute: typeof RestoreAccountRoute
  StoryboardRoute: typeof StoryboardRoute
  TextsRoute: typeof TextsRoute
  TimelineRoute: typeof TimelineRoute
  ArcsIdRoute: typeof ArcsIdRoute
  CharactersNewRoute: typeof CharactersNewRoute
  CharactersSettingsRoute: typeof CharactersSettingsRoute
  CodexNewRoute: typeof CodexNewRoute
  CodexSettingsRoute: typeof CodexSettingsRoute
  EventsNewRoute: typeof EventsNewRoute
  EventsSettingsRoute: typeof EventsSettingsRoute
  LocationsNewRoute: typeof LocationsNewRoute
  LocationsSettingsRoute: typeof LocationsSettingsRoute
  OrganizationsNewRoute: typeof OrganizationsNewRoute
  OrganizationsSettingsRoute: typeof OrganizationsSettingsRoute
  PublishEditorChapterIdRoute: typeof PublishEditorChapterIdRoute
  ReadNovelIdRoute: typeof ReadNovelIdRouteWithChildren
  ScenesNewRoute: typeof ScenesNewRoute
  ArcsIndexRoute: typeof ArcsIndexRoute
  CharactersIndexRoute: typeof CharactersIndexRoute
  CodexIndexRoute: typeof CodexIndexRoute
  EventsIndexRoute: typeof EventsIndexRoute
  ImportIndexRoute: typeof ImportIndexRoute
  LocationsIndexRoute: typeof LocationsIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  RelationshipsIndexRoute: typeof RelationshipsIndexRoute
  ScenesIndexRoute: typeof ScenesIndexRoute
  CharactersEditIdRoute: typeof CharactersEditIdRoute
  CharactersViewIdRoute: typeof CharactersViewIdRoute
  CodexEditIdRoute: typeof CodexEditIdRoute
  CodexViewIdRoute: typeof CodexViewIdRoute
  EventsEditIdRoute: typeof EventsEditIdRoute
  EventsViewIdRoute: typeof EventsViewIdRoute
  ImportProcessingSessionIdRoute: typeof ImportProcessingSessionIdRoute
  ImportReviewSessionIdRoute: typeof ImportReviewSessionIdRoute
  LocationsEditIdRoute: typeof LocationsEditIdRoute
  LocationsMapIdRoute: typeof LocationsMapIdRoute
  LocationsViewIdRoute: typeof LocationsViewIdRoute
  OrganizationsEditIdRoute: typeof OrganizationsEditIdRoute
  OrganizationsViewIdRoute: typeof OrganizationsViewIdRoute
  RelationshipsEntityTypeIdRoute: typeof RelationshipsEntityTypeIdRoute
  ScenesEditIdRoute: typeof ScenesEditIdRoute
  ScenesViewIdRoute: typeof ScenesViewIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/timeline': {
      id: '/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof TimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/texts': {
      id: '/texts'
      path: '/texts'
      fullPath: '/texts'
      preLoaderRoute: typeof TextsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storyboard': {
      id: '/storyboard'
      path: '/storyboard'
      fullPath: '/storyboard'
      preLoaderRoute: typeof StoryboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restore-account': {
      id: '/restore-account'
      path: '/restore-account'
      fullPath: '/restore-account'
      preLoaderRoute: typeof RestoreAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notes': {
      id: '/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof NotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/narrative-structure': {
      id: '/narrative-structure'
      path: '/narrative-structure'
      fullPath: '/narrative-structure'
      preLoaderRoute: typeof NarrativeStructureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export': {
      id: '/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor': {
      id: '/editor'
      path: '/editor'
      fullPath: '/editor'
      preLoaderRoute: typeof EditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout-success': {
      id: '/checkout-success'
      path: '/checkout-success'
      fullPath: '/checkout-success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout-cancel': {
      id: '/checkout-cancel'
      path: '/checkout-cancel'
      fullPath: '/checkout-cancel'
      preLoaderRoute: typeof CheckoutCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/adeptus-administratum': {
      id: '/adeptus-administratum'
      path: '/adeptus-administratum'
      fullPath: '/adeptus-administratum'
      preLoaderRoute: typeof AdeptusAdministratumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-pending-deletion': {
      id: '/account-pending-deletion'
      path: '/account-pending-deletion'
      fullPath: '/account-pending-deletion'
      preLoaderRoute: typeof AccountPendingDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scenes/': {
      id: '/scenes/'
      path: '/scenes'
      fullPath: '/scenes/'
      preLoaderRoute: typeof ScenesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/relationships/': {
      id: '/relationships/'
      path: '/relationships'
      fullPath: '/relationships/'
      preLoaderRoute: typeof RelationshipsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations/': {
      id: '/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof LocationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/': {
      id: '/import/'
      path: '/import'
      fullPath: '/import/'
      preLoaderRoute: typeof ImportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/codex/': {
      id: '/codex/'
      path: '/codex'
      fullPath: '/codex/'
      preLoaderRoute: typeof CodexIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters/': {
      id: '/characters/'
      path: '/characters'
      fullPath: '/characters/'
      preLoaderRoute: typeof CharactersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arcs/': {
      id: '/arcs/'
      path: '/arcs'
      fullPath: '/arcs/'
      preLoaderRoute: typeof ArcsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scenes/new': {
      id: '/scenes/new'
      path: '/scenes/new'
      fullPath: '/scenes/new'
      preLoaderRoute: typeof ScenesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read/$novelId': {
      id: '/read/$novelId'
      path: '/read/$novelId'
      fullPath: '/read/$novelId'
      preLoaderRoute: typeof ReadNovelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/publish-editor/$chapterId': {
      id: '/publish-editor/$chapterId'
      path: '/publish-editor/$chapterId'
      fullPath: '/publish-editor/$chapterId'
      preLoaderRoute: typeof PublishEditorChapterIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/settings': {
      id: '/organizations/settings'
      path: '/organizations/settings'
      fullPath: '/organizations/settings'
      preLoaderRoute: typeof OrganizationsSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/new': {
      id: '/organizations/new'
      path: '/organizations/new'
      fullPath: '/organizations/new'
      preLoaderRoute: typeof OrganizationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations/settings': {
      id: '/locations/settings'
      path: '/locations/settings'
      fullPath: '/locations/settings'
      preLoaderRoute: typeof LocationsSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations/new': {
      id: '/locations/new'
      path: '/locations/new'
      fullPath: '/locations/new'
      preLoaderRoute: typeof LocationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/settings': {
      id: '/events/settings'
      path: '/events/settings'
      fullPath: '/events/settings'
      preLoaderRoute: typeof EventsSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/new': {
      id: '/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof EventsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/codex/settings': {
      id: '/codex/settings'
      path: '/codex/settings'
      fullPath: '/codex/settings'
      preLoaderRoute: typeof CodexSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/codex/new': {
      id: '/codex/new'
      path: '/codex/new'
      fullPath: '/codex/new'
      preLoaderRoute: typeof CodexNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters/settings': {
      id: '/characters/settings'
      path: '/characters/settings'
      fullPath: '/characters/settings'
      preLoaderRoute: typeof CharactersSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters/new': {
      id: '/characters/new'
      path: '/characters/new'
      fullPath: '/characters/new'
      preLoaderRoute: typeof CharactersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arcs/$id': {
      id: '/arcs/$id'
      path: '/arcs/$id'
      fullPath: '/arcs/$id'
      preLoaderRoute: typeof ArcsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read/$novelId/': {
      id: '/read/$novelId/'
      path: '/'
      fullPath: '/read/$novelId/'
      preLoaderRoute: typeof ReadNovelIdIndexRouteImport
      parentRoute: typeof ReadNovelIdRoute
    }
    '/scenes/view/$id': {
      id: '/scenes/view/$id'
      path: '/scenes/view/$id'
      fullPath: '/scenes/view/$id'
      preLoaderRoute: typeof ScenesViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scenes/edit/$id': {
      id: '/scenes/edit/$id'
      path: '/scenes/edit/$id'
      fullPath: '/scenes/edit/$id'
      preLoaderRoute: typeof ScenesEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/relationships/$entityType/$id': {
      id: '/relationships/$entityType/$id'
      path: '/relationships/$entityType/$id'
      fullPath: '/relationships/$entityType/$id'
      preLoaderRoute: typeof RelationshipsEntityTypeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read/$novelId/$chapterId': {
      id: '/read/$novelId/$chapterId'
      path: '/$chapterId'
      fullPath: '/read/$novelId/$chapterId'
      preLoaderRoute: typeof ReadNovelIdChapterIdRouteImport
      parentRoute: typeof ReadNovelIdRoute
    }
    '/organizations/view/$id': {
      id: '/organizations/view/$id'
      path: '/organizations/view/$id'
      fullPath: '/organizations/view/$id'
      preLoaderRoute: typeof OrganizationsViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/edit/$id': {
      id: '/organizations/edit/$id'
      path: '/organizations/edit/$id'
      fullPath: '/organizations/edit/$id'
      preLoaderRoute: typeof OrganizationsEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations/view/$id': {
      id: '/locations/view/$id'
      path: '/locations/view/$id'
      fullPath: '/locations/view/$id'
      preLoaderRoute: typeof LocationsViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations/map/$id': {
      id: '/locations/map/$id'
      path: '/locations/map/$id'
      fullPath: '/locations/map/$id'
      preLoaderRoute: typeof LocationsMapIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations/edit/$id': {
      id: '/locations/edit/$id'
      path: '/locations/edit/$id'
      fullPath: '/locations/edit/$id'
      preLoaderRoute: typeof LocationsEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/review/$sessionId': {
      id: '/import/review/$sessionId'
      path: '/import/review/$sessionId'
      fullPath: '/import/review/$sessionId'
      preLoaderRoute: typeof ImportReviewSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/processing/$sessionId': {
      id: '/import/processing/$sessionId'
      path: '/import/processing/$sessionId'
      fullPath: '/import/processing/$sessionId'
      preLoaderRoute: typeof ImportProcessingSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/view/$id': {
      id: '/events/view/$id'
      path: '/events/view/$id'
      fullPath: '/events/view/$id'
      preLoaderRoute: typeof EventsViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/edit/$id': {
      id: '/events/edit/$id'
      path: '/events/edit/$id'
      fullPath: '/events/edit/$id'
      preLoaderRoute: typeof EventsEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/codex/view/$id': {
      id: '/codex/view/$id'
      path: '/codex/view/$id'
      fullPath: '/codex/view/$id'
      preLoaderRoute: typeof CodexViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/codex/edit/$id': {
      id: '/codex/edit/$id'
      path: '/codex/edit/$id'
      fullPath: '/codex/edit/$id'
      preLoaderRoute: typeof CodexEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters/view/$id': {
      id: '/characters/view/$id'
      path: '/characters/view/$id'
      fullPath: '/characters/view/$id'
      preLoaderRoute: typeof CharactersViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters/edit/$id': {
      id: '/characters/edit/$id'
      path: '/characters/edit/$id'
      fullPath: '/characters/edit/$id'
      preLoaderRoute: typeof CharactersEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ReadNovelIdRouteChildren {
  ReadNovelIdChapterIdRoute: typeof ReadNovelIdChapterIdRoute
  ReadNovelIdIndexRoute: typeof ReadNovelIdIndexRoute
}

const ReadNovelIdRouteChildren: ReadNovelIdRouteChildren = {
  ReadNovelIdChapterIdRoute: ReadNovelIdChapterIdRoute,
  ReadNovelIdIndexRoute: ReadNovelIdIndexRoute,
}

const ReadNovelIdRouteWithChildren = ReadNovelIdRoute._addFileChildren(
  ReadNovelIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountPendingDeletionRoute: AccountPendingDeletionRoute,
  AdeptusAdministratumRoute: AdeptusAdministratumRoute,
  CheckoutCancelRoute: CheckoutCancelRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  EditorRoute: EditorRoute,
  ExportRoute: ExportRoute,
  LibraryRoute: LibraryRoute,
  LoginRoute: LoginRoute,
  NarrativeStructureRoute: NarrativeStructureRoute,
  NotesRoute: NotesRoute,
  PricingRoute: PricingRoute,
  ProfileRoute: ProfileRoute,
  RestoreAccountRoute: RestoreAccountRoute,
  StoryboardRoute: StoryboardRoute,
  TextsRoute: TextsRoute,
  TimelineRoute: TimelineRoute,
  ArcsIdRoute: ArcsIdRoute,
  CharactersNewRoute: CharactersNewRoute,
  CharactersSettingsRoute: CharactersSettingsRoute,
  CodexNewRoute: CodexNewRoute,
  CodexSettingsRoute: CodexSettingsRoute,
  EventsNewRoute: EventsNewRoute,
  EventsSettingsRoute: EventsSettingsRoute,
  LocationsNewRoute: LocationsNewRoute,
  LocationsSettingsRoute: LocationsSettingsRoute,
  OrganizationsNewRoute: OrganizationsNewRoute,
  OrganizationsSettingsRoute: OrganizationsSettingsRoute,
  PublishEditorChapterIdRoute: PublishEditorChapterIdRoute,
  ReadNovelIdRoute: ReadNovelIdRouteWithChildren,
  ScenesNewRoute: ScenesNewRoute,
  ArcsIndexRoute: ArcsIndexRoute,
  CharactersIndexRoute: CharactersIndexRoute,
  CodexIndexRoute: CodexIndexRoute,
  EventsIndexRoute: EventsIndexRoute,
  ImportIndexRoute: ImportIndexRoute,
  LocationsIndexRoute: LocationsIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  RelationshipsIndexRoute: RelationshipsIndexRoute,
  ScenesIndexRoute: ScenesIndexRoute,
  CharactersEditIdRoute: CharactersEditIdRoute,
  CharactersViewIdRoute: CharactersViewIdRoute,
  CodexEditIdRoute: CodexEditIdRoute,
  CodexViewIdRoute: CodexViewIdRoute,
  EventsEditIdRoute: EventsEditIdRoute,
  EventsViewIdRoute: EventsViewIdRoute,
  ImportProcessingSessionIdRoute: ImportProcessingSessionIdRoute,
  ImportReviewSessionIdRoute: ImportReviewSessionIdRoute,
  LocationsEditIdRoute: LocationsEditIdRoute,
  LocationsMapIdRoute: LocationsMapIdRoute,
  LocationsViewIdRoute: LocationsViewIdRoute,
  OrganizationsEditIdRoute: OrganizationsEditIdRoute,
  OrganizationsViewIdRoute: OrganizationsViewIdRoute,
  RelationshipsEntityTypeIdRoute: RelationshipsEntityTypeIdRoute,
  ScenesEditIdRoute: ScenesEditIdRoute,
  ScenesViewIdRoute: ScenesViewIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
